import React, { useEffect, useState } from 'react';
import { /* useDispatch, */ useSelector } from 'react-redux';

import {/*  MyThunkDispatch, */ RootState } from 'store';
import useStoreTranslation from 'hooks/useStoreTranslation';
import useToast from 'hooks/useToast';
import ResellerForm from 'screens/components/ResellerForm';
import { extractErrorMessage } from 'utils/generic';
import { useParams } from 'react-router-dom';
import { getTravelReason } from 'services/resellerTravel';
import { DataTravelReason } from 'models/travelReseller';

const ResellerFormContainer = () => {
/*   const dispatch: MyThunkDispatch = useDispatch(); */
  const { /* company, */ isLoading, error } = useSelector((state: RootState) => state.companyBilling);
  const toast = useToast();
  const { t } = useStoreTranslation();
  const { travelReasonId } = useParams<{ travelReasonId?: string }>();
  const [travelReasonSelected, setTravelReasonSelected] = useState<DataTravelReason | undefined>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (error) toast.add({ type: 'danger', message: extractErrorMessage(error) || t('defaultError.default') });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (!travelReasonId) {setLoading(true); return;}

    getTravelReasonId();
  }, []);
  
  const getTravelReasonId = async () => {
    setLoading(false)
    try {
      const data = await getTravelReason(travelReasonId);
      if (data) {
        setTravelReasonSelected(data);
        setLoading(true)
      }
    } catch (error) {
      toast.add({
        type: 'danger',
        // @ts-ignore
        message: error.message,
      });
      setLoading(false);
    }
  };

  return <>{loading && <ResellerForm isLoading={isLoading} travelReasonSelected={travelReasonSelected} />}</>;
};

export default ResellerFormContainer;
